import React from 'react';
import { Box } from 'vindi-ds-components';
import MeasurementUnit from './components/measurement_unit';
import MinimumPrice from './components/minimum_price';
import PriceRange from './components/price_range';

function VolumeRange({ type, priceRangeErrors }) {
  return (
    <Box data-testid='volume-range-input'>
      <PriceRange type={type} priceRangeErrors={priceRangeErrors} />
      <MeasurementUnit />
      <MinimumPrice />
    </Box>
  );
}

export default VolumeRange;
